import { Component, OnInit, inject, model } from '@angular/core';
import { ImagesService } from '../services/images.service';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from '../../core/services/access.service';
import { ImageModel } from '../../shared/models/image.model';
import { ImagesFormComponent } from "../images-form/images-form.component";
import { Image } from '../models/image.model';
import { ImageInterface } from '../interfaces/image.interface';

@Component({
  selector: 'app-images-details',
  standalone: true,
  imports: [ImagesFormComponent],
  templateUrl: './images-details.component.html',
  styleUrl: './images-details.component.css'
})
export class ImagesDetailsComponent implements OnInit {
  private service = inject(ImagesService);
  private route = inject(ActivatedRoute);
  protected access = inject(AccessService).access;

  protected id!: string | null;

  protected value = model<Image | undefined>(undefined)

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles de la Imagen')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    // console.log('getContract', id)
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.get(id).subscribe(data => {
        data = data as ImageInterface;
        this.value.update(value => {
          value = Image.from(data as ImageInterface);
          // console.log('imagen: ', value)
          if (!value) {
            return undefined;
          }
          return value;
        });
      });
    }
  }
}
